import { consolidationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const getConsolidationCancellation = {
  name: "getConsolidationCancellation" as const,
  input: z.object({ consolidationId: consolidationIdFormat.schema }),
  output: z.object({ cancelledAt: z.date(), reason: z.string().nullable() }),
};
